<template>
  <div class="tickets-detail-dialog">
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="860px" :destroy-on-close="true"
      append-to-body :before-close="cancel" class="audit-dialog">
      <div class="el-dialog-div">
        <!-- 发票信息 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-document"></i> 发票信息</span>
            <i :class="sectionOpen.invoiceInfo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
              @click="toggleSection('invoiceInfo')" style="cursor: pointer; font-size: 14px; color: #909399;"></i>
          </div>
          <div class="tab-content" v-show="sectionOpen.invoiceInfo">
            <div class="detail-grid">
              <div class="detail-item">
                <span class="detail-label">审核状态</span>
                <span class="detail-value">
                  <el-tag :type="getStatusColor(auditStatus, 'tagType')"
                    :style="{ color: getStatusColor(auditStatus, 'color'), 'background-color': getStatusColor(auditStatus, 'backgroundColor') }">
                    {{ getStatusColor(auditStatus, 'name') }}</el-tag>
                </span>
              </div>
              <div class="detail-item" v-if="refundAuditStatus !== ''">
                <span class="detail-label">退票审核状态</span>
                <span class="detail-value">
                  <el-tag :type="getStatusColor(refundAuditStatus, 'tagType')"
                    :style="{ color: getStatusColor(refundAuditStatus, 'color'), 'background-color': getStatusColor(refundAuditStatus, 'backgroundColor') }">
                    {{ getStatusColor(refundAuditStatus, 'name') }}</el-tag>
                </span>
              </div>
              <div class="detail-item" v-if="invoiceStatus !== ''">
                <span class="detail-label">发票状态</span>
                <span class="detail-value">
                  <el-tag :type="getInvoiceColor(invoiceStatus, 'tagType')"
                    :style="{ color: getInvoiceColor(invoiceStatus, 'color'), 'background-color': getInvoiceColor(invoiceStatus, 'backgroundColor') }">
                    {{ getInvoiceColor(invoiceStatus, 'name') }}</el-tag>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建人</span>
                <span class="detail-value">{{ form.createBy }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">创建时间</span>
                <span class="detail-value">{{ form.createTime }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">开票单位</span>
                <span class="detail-value">{{ businessName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票抬头</span>
                <span class="detail-value">{{ invoiceTitle }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">负责人</span>
                <span class="detail-value">{{ invoiceInfo['invoicingPrincipal'].name }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">销售</span>
                <span class="detail-value">{{ invoiceInfo['sale'].name }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">合同</span>
                <span class="detail-value">
                  <el-link v-for="(contractNumber, index) in contractNumbers" :key="'contract' + index" type="primary"
                    @click="openContractDialog(contractNumber)">{{ contractNumber + ' ,' }}</el-link>
                </span>
              </div>
              <div class="detail-item">
                <span class="detail-label">纳税登记编号</span>
                <span class="detail-value">{{ taxRegistrationNumber }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">开户行&帐号</span>
                <span class="detail-value">{{ bankAccountNumber }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票金额</span>
                <span class="detail-value"><span class="amount-text">{{ form.invoiceAmount }}</span></span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票类型</span>
                <span class="detail-value">{{ form.invoiceType }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">发票内容</span>
                <span class="detail-value">{{ form.invoiceContent }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">备注</span>
                <span class="detail-value">{{ form.remark }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 发票信息导入 -->
        <div class="section-card">
          <div class="section-header-bar">
            <span class="section-title"><i class="el-icon-upload"></i> 发票信息导入</span>
          </div>
          <div>
            <div class="invoice-form">
              <el-form label-width="90px" ref="formA" :model="invoice" class="invoice-preview-form">
                <el-form-item label="发票抬头:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceTitle" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票单位:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.businessName" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票金额:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceAmount" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
                <el-form-item label="开票日期:">
                  <el-input style="width: 260px;" size="small" v-model="invoice.invoiceDate" auto-complete="off"
                    readonly></el-input>
                </el-form-item>
              </el-form>
              <el-form label-width="120px" ref="form" label-position="top" :model="form" :rules="rules" class="invoice-upload-form">
                <el-form-item label="发票信息导入：" prop="appendix" style="margin: 0 0 0 0">
                  <el-upload class="upload-demo" style="width: 100%" drag action="" accept=".pdf" :auto-upload="false"
                    :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList" :limit="1"
                    :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">仅接受pdf文件，将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" class="title" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">开票</el-button>
      </div>
    </el-dialog>
    <contract-details v-if="showContractDetails" :show-dialog="showContractDetails" :select-detail="[ContractDetail]"
      @submit="close1"></contract-details>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>
import {editTickets, getPdfNum} from "@/api/dilivery/tickets";
import {getContractPage} from "@/api/dilivery/sales/contract";
import ContractDetails from "@/components/sales/ContractDetails.vue";
import {viewDetailIcon} from "@/utils/icon";
import {getInvoiceColor, getStatusColor} from "@/color";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "TicketsDetail",
  components: { ContractDetails, Loading },
  props: ['showDialog', 'selectDetail'],
  data() {
    return {
      loading:false,
      showContractDetails: false,
      ContractDetail: '',
      title: '导入开票信息',
      sectionOpen: {
        invoiceInfo: true,
      },
      fileList: [], // 附件上传文件列表
      auditStatus: '',
      refundAuditStatus: '',
      invoiceInfo: {},
      invoiceStatus: '',
      bankAccountNumber: '',
      taxRegistrationNumber: '',
      invoiceTitle: '',
      businessName: '',
      contractNumbers: [],
      invoice: {
        invoiceNumber:'',
        invoiceTitle: '',
        invoiceAmount: '',
        invoiceDate: '',
        businessName: ''
      },
      form: {
        appendixExist: true,
        appendix: null,
        invoiceNumber: '',
        invoiceAmount: 0,
        invoiceType: '普票',
        remark: '',
        invoiceDate: ''
      },
      rules: {
        invoiceNumber: [
          {required: true, message: '请输入发票号码', trigger: 'change'}
        ],
        appendix: [
          {required: true, message: '请上传附件', trigger: 'change'}
        ],
      },
      viewDetailIcon: viewDetailIcon,
    }
  },
  watch: {
    'form.appendix': {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.getNum()
        }
      },
      immediate: true
    },
    'selectDetail': {
      handler(newVal) {
        if (newVal && Object.keys(newVal)) {
          this.form.id = newVal.id
          this.auditStatus = newVal.auditStatus
          if (newVal.refundAuditStatus !== null) {
            this.refundAuditStatus = newVal.refundAuditStatus
          }
          if (newVal.invoiceStatus !== null) {
            this.invoiceStatus = newVal.invoiceStatus
          }
          this.invoiceInfo = {...newVal}
          this.contractNumbers = newVal.contractNumbers
          this.invoiceTitle = newVal.invoiceTitle
          this.taxRegistrationNumber = newVal.taxRegistrationNumber
          this.bankAccountNumber = newVal.bankAccountNumber
          this.form.createBy = newVal.createBy
          this.businessName = newVal['billingUnit'].companyName
          this.form.invoiceRecordId = newVal.invoiceRecordId
          this.form.createTime = newVal.createTime
          this.form.invoiceAmount = newVal.invoiceAmount
          this.form.invoiceNumber = newVal.invoiceNumber
          this.form.invoiceType = newVal.invoiceType
          this.form.invoiceContent = newVal.invoiceContent
          this.form.remark = newVal.remark
        }
      },
      immediate: true
    },
  },
  methods: {
    toggleSection(key) {
      this.sectionOpen[key] = !this.sectionOpen[key];
    },
    getStatusColor,
    getInvoiceColor,
    getNum(){
        let param = {
          'id' : this.form.id
        }
        const formData = new FormData();
        if (this.form.appendix) {
          formData.append('file', this.form.appendix.raw); // 文件
        } else {
          const emptyFile = new File([], '')
          formData.append('file', emptyFile);
        }
        getPdfNum(param,formData).then(res=>{
          if(res.code === 200){
            this.form.invoiceNumber = res.data.invoiceNumber
            this.invoice.invoiceNumber = res.data.invoiceNumber
            this.invoice.invoiceAmount = res.data['invoicePrice']
            this.invoice.invoiceDate = res.data['invoiceDate']
            const name = res.data['name'].split(',')
            this.invoice.invoiceTitle = name[0].trim()
            this.invoice.businessName = name[1].trim()
          }
        }).catch(err => {
          this.form.invoiceNumber = ''
          this.invoice.invoiceAmount = ''
          this.invoice.invoiceDate = ''
          this.invoice.invoiceTitle = ''
          this.invoice.businessName = ''
        })
    },
    close1() {
      this.$nextTick(() => {
        this.showContractDetails = false
      })
    },
    openContractDialog(contractNumber) {
      let param = {}
      let data = {
        "query#contractNumber.EQ": contractNumber
      }
      getContractPage(param, data).then(res => {
        if (res.code === 200) {
          if (res.data.records.length === 0) {
            this.$messageUi.error("打开合同详情失败")
          } else {
            this.ContractDetail = res.data.records[0]
            this.showContractDetails = true
          }
        }
      }).catch(error => {
      })
    },
    handleChange(file, fileList) {
      // 当文件选择发生变化时触发此方法
      this.form.appendix = file; // 更新已选择的文件
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      // 可选，处理文件移除逻辑
      this.form.appendix = null; // 更新已选择的文件
      this.fileList = fileList
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传'); // 超出数量时提醒
    },
    cancel() {
      this.$emit('submit', 'cancel')
    },
    formatAmount(amount) {
      const parsedAmount = parseFloat(amount);
      return parsedAmount.toFixed(2);
    },
    removeSpaces(str) {
      return str.replace(/[^\u4e00-\u9fa5]/g, '');
    },
    compareInvoice() {
      // const isCompany = this.removeSpaces(this.invoice.invoiceTitle) !== this.removeSpaces(this.invoiceTitle);
      const isCompany = !this.removeSpaces(this.invoiceTitle).includes(this.removeSpaces(this.invoice.invoiceTitle)) && !this.removeSpaces(this.invoice.invoiceTitle).includes(this.removeSpaces(this.invoiceTitle));
      const isAmount = this.formatAmount(this.invoice.invoiceAmount) !== this.formatAmount(this.form.invoiceAmount);
      const isBusiness = this.removeSpaces(this.invoice.businessName) !== this.removeSpaces(this.businessName);
      return isCompany || isAmount || isBusiness;
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          if(this.compareInvoice()){
            this.$messageUi.error('导入发票信息与目标发票信息不一致，请检查')
            return
          }
          if(!this.invoice.invoiceDate){
            this.$messageUi.error('开票日期不存在，请检查')
            return
          }
          this.loading = true
          const formData = new FormData();
          if (this.form.appendix) {
            formData.append('file', this.form.appendix.raw); // 文件
          } else {
            const emptyFile = new File([], '')
            formData.append('file', emptyFile);
          }
          // 为开票日期赋值
          this.form.invoiceDate=this.invoice.invoiceDate
          const jsonStr = JSON.stringify(
              Object.keys(this.form).reduce((acc, key) => {
                if (key !== 'appendix') {
                  acc[key] = this.form[key];
                }
                return acc;
              }, {})
          );
          const blob = new Blob([jsonStr], {
            type: 'application/json'
          });
          formData.append("info", blob);
          editTickets(formData).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.$store.commit('right/setChangeRed',true)
              this.$messageUi.success('添加成功')
              this.$emit('submit', 'confirm')
            }
          }).catch(err => {
            this.loading = false
          })
        } else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.tickets-detail-dialog {
  ::v-deep .audit-dialog {
    .el-dialog__header {
      
      padding: 15px 20px;
      
       .el-dialog__title {
        font-weight: 600;
      }
      
      
    }
    
    .el-dialog__body {
      padding: 20px;
    }
  }
}
@import "@/assets/css/mixins.scss";
@import "@/assets/css/detail.css";
.el-dialog-div {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 5px;
  
  @include thin-scrollbar(8px, #888);
}

.invoice-form {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
}

.invoice-preview-form {
  width: 45%;
}

.invoice-upload-form {
  width: 55%;
}

.upload-demo {
  margin-top: 10px;
}

</style>
